import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getPetVets } from '@/services/pets.services'
import {
  PAYMENT_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { PetVet } from '@/shared/types/global.types'

const MIN_SEARCH_LENGTH = 3

export function usePetVets(search: string) {
  const term = search.trim()

  return useQuery<PetVet[]>({
    queryKey: PAYMENT_QUERY_KEYS.petVets(term),
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPetVets(token, term)
    },
    enabled: term.length >= MIN_SEARCH_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
